/**
 * @file options for the Tooltip UI component
 * @see https://docs.jointjs.com/api/ui/Tooltip#options
 */
import { ui } from '@joint/plus';
export const target = '[data-tooltip]';
export const direction = ui.Tooltip.TooltipArrowPosition.Auto;
export const padding = 12;
export const animation = {
    delay: '250ms'
};
